import { render, staticRenderFns } from "./GFruns.vue?vue&type=template&id=4db8177e"
import script from "./GFruns.vue?vue&type=script&lang=js"
export * from "./GFruns.vue?vue&type=script&lang=js"
import style0 from "./GFruns.vue?vue&type=style&index=0&id=4db8177e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports